import { useMemo } from "react";

export interface GitHubSourceSettingsText {
  repositoriesLabelText: string;
  repositoriesPlaceholderText: string;
  repositoriesHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useGitHubSourceSettingsText = (
  t: (key: string) => string,
): GitHubSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.github.${key}`);

    return {
      repositoriesLabelText: tKey("repositoriesLabel"),
      repositoriesPlaceholderText: tKey("repositoriesPlaceholder"),
      repositoriesHintText: tKey("repositoriesHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
